<template>
  <div id="page-SPAR">

    <h5 class="m-4 page-header"> >> SPAR</h5>

    <memlist-card>
      <div class="ml-tabs">
        <div class="ml-tabs-header">
          <button
            type="button"
            v-for="(tab, i) in tabs"
            :key="i"
            :class="['ml-tab-button', active_tab === i ? 'active' : '']"
            @click="active_tab = i"
            :disabled="tab.disabled"
          >
            {{ $t(tab.label) }}
          </button>
        </div>

        <div class="ml-tabs-body">
          <div v-show="active_tab === 0">
            <SPARJobTable
              ref="sparJobTable"
            />
          </div>
          <div v-show="active_tab === 1">
          </div>
        </div>
      </div>
    </memlist-card>
  </div>
</template>


<script>

import axios from 'axios';
import { mapGetters } from 'vuex';
import SPARJobTable from '@/view/pages/ml/spar/SPARJobTable.vue';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';


export default {
  name: 'spar',
  components: {
    SPARJobTable
  },
  mixins: [ toasts ],
  computed: {
    tabs() {

      let base = [
        { label: 'SPAR.SPAR', disabled: false },
        { label: 'COMMON.SETTINGS', disabled: false },

      ];
      
      return base;
    },
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'periods', 'reg_only']),
  },
  mounted() {
    const loader = this.$loading.show();


    loader && loader.hide();
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  watch: {
    currentCompanyId(newValue, oldvalue) {
      if (newValue) {

      }
    },
  },
  methods: {

  }
};
</script>
